import { TCategoryProductSheet, TProductSheet } from '../../../types/product';
import { InitializeCommodityCategory } from './InitializeCommodityCategory';

export const InitializeProductSheet = (): TProductSheet => ({
  display: true,
  fresh: true,
  shelfLife: 0,
  shelfLifeUnit: 0,
  unitsOfMeasure: {
    units: [],
    default: 0,
  },
});

export const InitializeCategoryProductSheet = (): TCategoryProductSheet => ({
  display: true,
  fresh: true,
  shelfLife: 0,
  shelfLifeUnit: 0,
  unitsOfMeasure: {
    units: [],
    default: 0,
  },
  category: InitializeCommodityCategory(),
});
